
export class GeneralAttachmentsData {
  canUpload!: boolean
  totalCount!: number
  data!: ListGeneralAttachmentsModel[]
}

export class ListGeneralAttachmentsModel {
  id!: number
  name!: string
  size!: string
  extension!: string
  path!: string
  createdByName!: string
  createdByLogo!: string
  canDelete!: boolean
  createdDate!: string
  loading!:boolean
}

